import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loader from './components/UI/Loader';

const Dashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardContainer" */ './components/Dashboard'
    )
);
const Login = React.lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './components/Auth/Login')
);

const ForgotPassword = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ForgotPasswordPage" */ './components/Auth/ForgotPassword'
    )
);
const ResetPassword = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ResetPasswordPage" */ './components/Auth/ResetPassword'
    )
);
const SignUp = React.lazy(
  () => import(/* webpackChunkName: "SignUpPage" */ './components/Auth/SignUp')
);

function Routes() {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/signup" exact component={SignUp} />
        <Route path="/reset-password" exact component={ResetPassword} />
        <Route path="/forgot-password" exact component={ForgotPassword} />
        <Route path="/" component={Dashboard} />
      </Switch>
    </Suspense>
  );
}

export default Routes;
